export default __webpack_public_path__ + "static/media/425.29b76855.png";